import { Link, useParams } from "react-router-dom"

import Nav from 'react-bootstrap/Nav'

const UtgNav = ({ activeKey }) => {

    const { beId, componentId } = useParams()

    return (
        <Nav variant="tabs" size="sm" activeKey={activeKey} className="px-3 my-3">
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "1" ? " active" : "")} eventkey="1" to={`/be/${beId}/utgs/${componentId}`}>General</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "2" ? " active" : "")} eventkey="2" to={`/be/${beId}/utgs/${componentId}/apiinterfaces`}>API Interfaces</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "3" ? " active" : "")} eventkey="3" to={`/be/${beId}/utgs/${componentId}/devices`}>Devices</Link>
            </Nav.Item>
            <Nav.Item>
                <Link className={"nav-link".concat(activeKey == "4" ? " active" : "")} eventkey="4" to={`/be/${beId}/utgs/${componentId}/config`}>Configuration</Link>
            </Nav.Item>
        </Nav>
    )
}
export default UtgNav